module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/joint-venture/jv-agreements/jv-agreement-grid/jv-agreement-grid.component.css
// module id = ./src/app/landprocurement/joint-venture/jv-agreements/jv-agreement-grid/jv-agreement-grid.component.css
// module chunks = main